module.exports = __webpack_public_path__ + "img/syringe.c430ce11.svg";